

export const LOCALS = {

    en: {
        translation: {
            "label-show-all": "Show All",
            "label-materiales": "Materials",
            "label-paises": "Countries",
            "label-year-filter": "Year",
            "label-no-records": "The query did not return records requested",
            "label-concepto": "Concept",
            "label-initial-year": "Initial Year",
            "label-end-year": "End Year",
            "label-dowload-csv": "Download CSV"
        }
    },
    esp: {
        translation: {
            "label-show-all": "Mostrar todos",
            "label-materiales": "Materiales",
            "label-paises": "Paises",
            "label-year-filter": "Año",
            "label-no-records": "La consulta no encontro registros",
            "label-concepto": "Concepto",
            "label-initial-year": "Año Inicial",
            "label-end-year": "Año Final",
            "label-dowload-csv": "Descargar CSV"
        }
    }

}